import { ImageBypartAPIResponse } from 'src/api/searchResults/interfaces'
import PartExtServiceProvider from 'src/services/PartExtServiceProvider'

export interface GetImageUrlProps {
  linecode: string
  partnumber: string
  partImages: ImageBypartAPIResponse[]
}

export interface PartIdentifier {
  lineCode: string
  partNumber: string
}

export interface GetPartImagesProps {
  parts: Array<PartIdentifier>
}

export const getImageUrl = (props: GetImageUrlProps): string => {
  const { linecode, partnumber, partImages } = props
  const part = partImages?.find(
    (item) => item.partNumber === partnumber && item.linecode === linecode
  )
  if (part) {
    return part.partImages[0]?.url
  } else {
    return null // Return null if no matching part is found
  }
}

export const getPartImages = (
  props: GetPartImagesProps
): Promise<ImageBypartAPIResponse[]> => {
  const { parts } = props
  const byPartPayload = parts.map((part) => ({
    partNumber: part.partNumber,
    lineCode: part.lineCode,
  }))
  return PartExtServiceProvider.getPartAttributesByPart(byPartPayload)
}
